export const BUILDER_PUBLIC_API_KEY = "5d0546160e954b87b82e2663451afcb1";
export const GOOGLE_RECAPTCHA_SITE_KEY = "6LdBeJIqAAAAACpTX7s2imRmQT8qvOi2W21cM97B";
export const POSTHOG_API_KEY = "phc_oTCyVSWJE2G7RME3pLPGbSXxHvpUiwGZCpaCvAggYpY";
export const HUBSPOT_TRACKING_ID = "6155237";
/** Meta (Facebook) Pixel ID for advertising tracking */
export const META_PIXEL_ID = "3481438168844212";
/** LinkedIn Insight Tag Partner ID for advertising tracking */
export const LINKEDIN_PARTNER_ID = "8684354";
/** OpenAI Ads Measurement Pixel ID for ChatGPT Ads conversion tracking */
export const OPENAI_ADS_PIXEL_ID = "TXTzWPLRXCRYqryTyU7U1k";
/** Google Analytics 4 Measurement ID - must match ID in src/app.html */
export const GA4_MEASUREMENT_ID = "G-2J99XY0YR9";
/** Google Ads Conversion Tracking ID - must match ID in src/app.html */
export const GOOGLE_ADS_ID = "AW-1069726376";
